import Color from "color";

export const CENTER = {
  vertical: "middle",
  horizontal: "center",
};

export const RIGHT = {
  vertical: "middle",
  horizontal: "right",
};

export const CENTER_VERTICAL = {
  vertical: "middle",
};

export const COLOR = (color) => ({ argb: "FF" + color.slice(1) });

export const BORDER_LEFT = (color) => ({
  left: {
    style: "thin",
    color: COLOR(color),
  },
});

export const BORDER_RIGHT = (color) => ({
  right: {
    style: "thin",
    color: COLOR(color),
  },
});
export const BORDER_TOP = (color) => ({
  top: {
    style: "thin",
    color: COLOR(color),
  },
});

export const BORDER_BOTTOM = (color) => ({
  bottom: {
    style: "thin",
    color: COLOR(color),
  },
});

export const BORDER_HORIZONTAL = (color) => ({
  ...BORDER_LEFT(color),
  ...BORDER_RIGHT(color),
});

export const FILL = (color) => ({
  type: "pattern",
  pattern: "solid",
  fgColor: COLOR(color),
});

export const TITLE_ROW_HEIGHT = 30;


export const mixColor = (color, level, darken=false) => {
  const c = Color(color);
  const m = Color(darken ? "#000000" : "#FFFFFF");
  return new Color([
    c.color[0] + (m.color[0] - c.color[0]) / 4 * level,
    c.color[1] + (m.color[1] - c.color[1]) / 4 * level,
    c.color[2] + (m.color[2] - c.color[2]) / 4 * level,
  ]).hex();
}
